import { Edit} from "@mui/icons-material";
import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState,useContext } from "react";
import {  useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "../css/Register.css";
import { motion } from 'framer-motion'
import Loading from "./Loading";
import { AppContext } from "./context";
const Profile = () => {
  const {IsLoggedIn } = useContext(AppContext);

  const navigate = useNavigate();
  const { id } = useParams();
  const [Value, setValue] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (IsLoggedIn) {
      getData(id);
    } else {
      toast.info("Login First to View");
      setTimeout(() => {
        navigate("/")
      }, 3000);
    }
  }, [id]);
  const token = localStorage.getItem("authtoken");
  axios.defaults.headers.common["authorization"] = `Bearer ${token}`;
  const getData = async (Id) => {
    if (IsLoggedIn) {
    try {
      const response = await axios.get(`https://winterstore-backend.onrender.com/Profile/${Id}`);
      if (response.status === 200) {
        setValue(response.data);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Error while fetching details");
    }
  }
}
const handleClick = (id) => { 
  navigate(`/Profile/Edit/${id}`)

 }
  return (
    <motion.div
    initial={{x:'-100vw'}}
    animate={{x:0}}
    transition={{duration:2,type:"spring"}}>
    {loading ? (
      <div style={{marginTop:"320px"}}>
  <Loading text="Retriving Details...."/>
      </div>
    ) : (
    <div
      className="container p-5 mt-2 mb-2 box"
      style={{
        margin: "auto",
        backgroundColor: "#101E2B",
        boxShadow: "0 15px 25px rgba(0,0,0,.6)",
        borderRadius: "10px",
      }}
    >
      <p className="py-2">User Details</p>

      <div className="row ">
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <div class="user-box mt-2  ">
            <span>FirstName :</span>
            <label className="form-control "> {Value.FirstName} </label>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <div class="user-box mt-2 ">
            <span>Lastname :</span>
            <label className="form-control "> {Value.LastName} </label>
          </div>
        </div>
      </div>

      <div class="user-box mt-2 ">
        <span>Email Address :</span>
        <label className="form-control ">{Value.Email} </label>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <div class="user-box mt-2 ">
            <span>Mobile Number :</span>
            <label className="form-control "> {Value.Phone} </label>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <div class="user-box mt-2 ">
            <span>Zip Code :</span>
            <label className="form-control ">{Value.Zip} </label>
          </div>
        </div>
      </div>

      <div class="user-box mt-2 ">
        <span> Address :</span>
        <label className="form-control ">{Value.Address} </label>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <div class="user-box mt-2 ">
            <span>City :</span>
            <label className="form-control"> {Value.City} </label>
          </div>
        </div>
        <div className="col-md-6 col-sm-12 col-lg-6 ">
          <div class="user-box mt-2 ">
            <span>State :</span>
            <label className="form-control ">{Value.State} </label>
          </div>
        </div>
      </div>
      <div className=" row ">
          <div className="col-md-6 col-sm-12 col-lg-6 ">
          <Button
          type="submit"
          variant="contained"
          size="medium"
          className="text-center py-2 mt-2"
          startIcon={<Edit style={{color:"white"}} />}
          onClick={() => handleClick(id)}
          style={{ backgroundColor: "#149686" ,margin:"auto",   borderRadius: "5px"}}
          color="success"
        >
          Update Details
        </Button>
                 
        </div>
      </div>
    </div>)}
    </motion.div>
  
)};

export default Profile;
